
function flattenObjectsToIdsAndTrimStrings (input) {
	// Check if input is an object; if so, return just the id
	if (typeof input === 'object' && input !== null && input.id) {
		return input.id;
	}

	if (typeof input === 'string') {
		return input.trim();
	}

	return input;
}

export function flattenObjectDataInArray (array) {
	return array.map(item => {
		return flattenObjectsToIdsAndTrimStrings(item);
	});
}


// The main function to flatten form data.
// It will process one array deep as per the above functions
// Could be made recursive, but seems unnecessary for now, as
// I don't think our forms go that deep
export function flattenObjectData (form) {
	return Object.keys(form).reduce((acc, field) => ({
		...acc,
		[field]: Array.isArray(form[field]) ? flattenObjectDataInArray(form[field]) : flattenObjectsToIdsAndTrimStrings(form[field]),
	}), {});
}






// TEST DATA

// const a = {
// 	machine: 123,
// 	location: 123,
// 	client: {
// 		id: '12u3p',
// 	},
// 	person: {
// 		name: 'John',
// 	},
// 	machines: [
// 		{
// 			id: '123123123',
// 			name: 'test',
// 		},
// 		{
// 			id: 'aaa',
// 			name: 'Best',
// 		},
// 	],
// };
